export default {

  // 新增提货
  insertYcDelivery: '/ygsjzs/ycnDelivery/insertYcnDelivery',
  // 修改提货
  updateYcDelivery: '/ygsjzs/ycnDelivery/updateYcnDelivery',
  // 修改真实提货数量,并上传磅单
  updateYcDeliverySpec: '/ygsjzs/ycnDelivery/updateYcnDeliverySpec',
  // 删除提货
  deleteYcDelivery: '/ygsjzs/ycnDelivery/deleteDataYcnDelivery',

  // 审批提货单
  approveYcDelivery: '/ygsjzs/ycnDelivery/approveYcnDelivery',

  // 查询提货列表
  // selectYcDeliveryByList: '/ygsjzs/ycDelivery/selectYcDeliveryByList',
  selectYcDeliveryByList: '/ygsjzs/ycnDelivery/selectYcnDeliveryByList',
  // 详情
  selectYcDeliveryByDeliveryId: '/ygsjzs/ycnDelivery/selectYcnDeliveryByDeliveryId',
  ycDeliveryByToPdf: '/ygsjzs/ycnDelivery/ycDeliveryByToPdf',
  selectYcnDelivery: '/ygsjzs/ycnDelivery/selectYcnDelivery',
  exportYcnDelivery: '/ygsjzs/ycnDelivery/exportYcnDelivery'
}
